export const capitalizeSlug = (slug: string): string => {
  if (!slug) {
    return ''
  }

  return slug
    .split('-')
    .map((word) =>
      word
        .toLowerCase()
        .replace(/\w/, (firstLetter) => firstLetter.toUpperCase())
    )
    .join(' ')
}
